import './scss/App.scss';
import { GeneralContextComponent } from './core/general.context';
import { LabelContextComponent } from "./core/label.context";
import { Loanching } from './components/configurator';


function App() {

    const search = window.location.search;
    const params = new URLSearchParams(search);

    return (
        <>
            <LabelContextComponent>
                <GeneralContextComponent>
                    <Loanching/>
                </GeneralContextComponent>
            </LabelContextComponent>

        </>
    );
}

export const Landing = (props: any) => {
    const container = document.getElementById("landing-fab-root");

}
export default App;
